<div class="ln-chip__name">{{ name }}</div>
<ln-icon name="cross" class="ln-chip__button" (click)="onDelete()" width="14px" height="14px"></ln-icon>
